<template>
  <timeline-item
    :type="type"
    :title="title"
    :date="date"
    :by-name="byName"
    color="is-activities"
  ></timeline-item>
</template>

<script>
import TimelineItem from "./TimelineItem";
import {ENUMS} from "../../services/enums";
import dates from "../../services/dates";

export default {
  name: "TimelineActivityRecord",
  components: {TimelineItem},
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    type() {
      if (this.activity.type === ENUMS.ActivityTypeEnum.FollowUpSequence.value) {
        switch (this.activity.action) {
          case ENUMS.ActivityActionEnum.Added.value:
            return 'Entered Follow Up Sequence'
          case ENUMS.ActivityActionEnum.Changed.value:
            return 'Paused Follow Up Sequence'
          case ENUMS.ActivityActionEnum.Resumed.value:
            return 'Resumed Follow Up Sequence'
          case ENUMS.ActivityActionEnum.Completed.value:
            return 'Completed Follow Up Sequence'
          case ENUMS.ActivityActionEnum.Canceled.value:
            return 'Cancelled Follow Up Sequence'
        }
      }

      const type = this.$utils.newGetEnumLabel(this.activity.type, ENUMS.ActivityTypeEnum);
      const action = this.$utils.newGetEnumLabel(this.activity.action, ENUMS.ActivityActionEnum);

      if(action === ENUMS.ActivityActionEnum.Initial.label) {
        return `${action} ${type}`;
      }

      return `${type} ${action}`;
    },
    title() {
      const oldValue = this.activity.old_value;
      const newValue = this.activity.new_value;

      // FYI: Appointment and Task types are taken care of in their own components

      switch (this.activity.type) {
        case ENUMS.ActivityTypeEnum.Campaign.value:
          const oldCampaign = (oldValue !== null) ? oldValue : 'No Campaign';
          const newCampaign = (newValue !== null) ? newValue : 'No Campaign';
          return `from ${oldCampaign} to ${newCampaign}`;

        case ENUMS.ActivityTypeEnum.Status.value:
        case ENUMS.ActivityTypeEnum.User.value:
          return newValue;

        case ENUMS.ActivityTypeEnum.Temperature.value:
          const oldTemp = this.$utils.newGetEnumLabel(parseInt(oldValue), ENUMS.TemperatureEnum);
          const newTemp = this.$utils.newGetEnumLabel(parseInt(newValue), ENUMS.TemperatureEnum);
          return `from ${oldTemp} to ${newTemp}`;
        case ENUMS.ActivityTypeEnum.Motivation.value:
          const oldMotivation = this.$utils.newGetEnumLabel(parseInt(oldValue), ENUMS.MotivationEnum);
          const newMotivation = this.$utils.newGetEnumLabel(parseInt(newValue), ENUMS.MotivationEnum);
          return `from ${oldMotivation} to ${newMotivation}`;

        case ENUMS.ActivityTypeEnum.FollowUpSequence.value: {
          return newValue.follow_up_sequence_template_label;
        }

        case ENUMS.ActivityTypeEnum.BuyingOffer.value:
          switch (this.activity.action) {
            case ENUMS.ActivityActionEnum.Added.value:
              return this.$utils.formatCurrency(newValue);
            case ENUMS.ActivityActionEnum.Deleted.value:
              return this.$utils.formatCurrency(oldValue);
            case ENUMS.ActivityActionEnum.Changed.value:
              const oldBuyingOfferStatus = this.$utils.newGetEnumLabel(parseInt(oldValue), ENUMS.BuyingOfferStatusEnum);
              const newBuyingOfferStatus = this.$utils.newGetEnumLabel(parseInt(newValue), ENUMS.BuyingOfferStatusEnum);

              return `${oldBuyingOfferStatus} to ${newBuyingOfferStatus}`;
            default:
              return '';
          }

        case ENUMS.ActivityTypeEnum.ExitStrategy.value:
          const oldStrategy = this.$utils.newGetEnumLabel(parseInt(oldValue), ENUMS.ExitStrategyEnum);
          const newStrategy = this.$utils.newGetEnumLabel(parseInt(newValue), ENUMS.ExitStrategyEnum);
          return `from ${oldStrategy} to ${newStrategy}`;

        case ENUMS.ActivityTypeEnum.Appointment.value: {
          return 'Appointment Activity';
        }

        default:
          return '';
      }
    },
    date() {
      return dates.formatAsDateTime(this.activity.created_at);
    },
    byName() {
      return this.activity.createdBy.display_name;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

</style>
